import { SxProps, Theme } from '@mui/material'

export const calendar: SxProps<Theme> = {
  width: 'inherit',
  height: 'inherit',
  position: 'relative',
  button: {
    font: 'inherit',
    cursor: 'pointer',
    color: 'inherit',
    transition: 'color, background-color 0.1s'
  },
  '.rbc-calendar': {
    padding: '20px',
    '*': {
      borderColor: (theme) => `${theme.palette.divider} !important`
    }
  },
  '.rbc-toolbar': {
    '.rbc-toolbar-label': {
      fontWeight: 'bold',
      textAlign: 'left'
    },
    '.rbc-active': {
      color: 'primary.contrastText',
      backgroundColor: 'primary.light',
      borderColor: 'primary.light',
      boxShadow: 'none'
    },
    button: {
      '&:hover': {
        color: 'primary.contrastText',
        backgroundColor: 'primary.main',
        borderColor: 'primary.main'
      },
      '&:focus': {
        color: 'primary.contrastText',
        backgroundColor: 'primary.light'
      }
    }
  },
  '.rbc-row-segment': {
    padding: '2px 5px',
    fontSize: 'small'
  },
  '.rbc-event': {
    color: 'primary.contrastText',
    backgroundColor: 'primary.light',
    transition: 'opacity 0.1s',
    '&:hover': {
      opacity: 0.8
    }
  },
  '.rbc-off-range-bg': {
    backgroundColor: 'action.selected'
  },
  '.rbc-today': {
    backgroundColor: 'inherit'
  },
  '.rbc-time-slot, .rbc-time-content': {
    border: 'none'
  },
  '.rbc-timeslot-group': {
    borderBottom: 'none'
  },
  '.rbc-event-label, .rbc-time-gutter, .rbc-time-header-gutter, .rbc-allday-cell, .rbc-current-time-indicator':
    {
      display: 'none'
    },
  '.rbc-events-container': {
    border: 'none',
    fontSize: 'small',
    margin: '10px 10px',
    'div[role=button]': {
      padding: '10px'
    }
  },
  '.rbc-time-view': {
    borderLeft: 'none'
  }
}

export const loading: SxProps<Theme> = {
  zIndex: 10,
  position: 'absolute',
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backdropFilter: 'blur(2px)'
}

export const spinner: SxProps<Theme> = {
  width: '48px',
  height: '48px',
  border: '5px solid',
  borderColor: '#efefef',
  borderBottomColor: 'primary.light',
  borderRadius: '50%',
  display: 'inline-block',
  boxSizing: 'border-box',
  animation: 'rotation 1s linear infinite',
  '@keyframes rotation': {
    '0%': {
      transform: 'rotate(0deg)'
    },
    '100%': {
      transform: 'rotate(360deg)'
    }
  }
}
